export default {
      id: "icon-arrow-right-usage",
      viewBox: "0 0 15 12",
      url: __webpack_public_path__ + "img/icons.50d286a4.svg#icon-arrow-right",
      toString: function () {
        return this.url;
      }
    }